import { FC, memo } from "react";

const delays = [0, 0.6, 1.2];

export const PulseEffect: FC = memo(() => {
  return (
    <div className="baseball-pulse-wrapper">
      {delays.map((delay) => (
        <div
          key={delay}
          className="baseball-pulse-ring"
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
      <div className="baseball-pulse-core" />
    </div>
  );
});
